/* eslint-disable */
import { createAsyncThunk, createAction } from '@reduxjs/toolkit';
import {
	lookup as userLookup,
	sso as ssoApi,
	sessionInfo as sessionInfoApi,
	logout as logoutApi,
	login as loginApi,
	refreshToken,
	updateUserPreferences,
	revokeAuth0RefreshToken
} from 'util/Api';
import { extLocalStore } from 'util/localStorage';
import { errorCodes } from 'appConstants';

const showPreferences = createAction('user/showPreferences');
const toggleSwitch = createAction('user/toggleSwitch');
const canAddCandidate = createAction('user/canAddCandidate');
const disableSwitch = createAction('user/disableSwitch');
const setAuthMethod = createAction('user/setAuthMethod');
const setTextRecruitDataFromExtension = createAction('user/setTextRecruitDataFromExtension');
const setCurrentExtensionWebPageOrigin = createAction('user/setCurrentExtensionWebPageOrigin');
const setIsInternal = createAction('user/setIsInternal');
const reset = createAction('reset');

const lookup = createAsyncThunk('user/lookup', async ({ username }, { rejectWithValue }) => {
	try {
		return await userLookup(username);
	} catch (err) {
		return rejectWithValue({ message: 'error' });
	}
});

const sso = createAsyncThunk('user/sso', async ({ username }, { rejectWithValue }) => {
	try {
		return await ssoApi(username);
	} catch (err) {
		return rejectWithValue(err);
	}
});

const sessionInfo = createAsyncThunk('user/sessionInfo', async (_args, { rejectWithValue }) => {
	try {
		return await sessionInfoApi();
	} catch (err) {
		return rejectWithValue(err);
	}
});

const login = createAsyncThunk(
	'user/login',
	async ({ username, password }, { rejectWithValue, dispatch }) => {
		try {
			const resp = await loginApi(username, password);
			dispatch(sessionInfo());
			return resp;
		} catch (err) {
			if (err.failReason === 'AuthenticationError') {
				err.code = errorCodes.UNAUTHENTICATED.code;
				err.message = errorCodes.UNAUTHENTICATED.message;
			}
			return rejectWithValue(err);
		}
	}
);

const logout = createAsyncThunk('user/logout', async (_args, { rejectWithValue }) => {
	try {
		/**
		 * No need to invoke /logout if user is logged in via Auth0.
		 * For Auth0 users we only need to revoke the refresh token.
		 */
		const isAuth0 = extLocalStore.auth0;
		if (isAuth0) {
			return await revokeAuth0RefreshToken();
		} else {
			return await logoutApi();
		}
	} catch (err) {
		return rejectWithValue(err);
	}
});

const updateBlacklist = createAsyncThunk(
	'user/updateBlacklist',
	async ({ updatedBlacklistDomains }, { rejectWithValue }) => {
		try {
			return await updateUserPreferences(updatedBlacklistDomains);
		} catch (err) {
			return rejectWithValue(err);
		}
	}
);

const updatePreferredPhoneRegions = createAsyncThunk(
	'user/updatePreferredPhoneRegions',
	async ({ phoneRegions }, { rejectWithValue }) => {
		try {
			return await updateUserPreferences(null, phoneRegions);
		} catch (err) {
			return rejectWithValue(err);
		}
	}
);

export const userActions = {
	lookup,
	sso,
	reset,
	login,
	sessionInfo,
	setAuthMethod,
	setIsInternal,
	canAddCandidate,
	logout,
	showPreferences,
	toggleSwitch,
	updateBlacklist,
	updatePreferredPhoneRegions,
	disableSwitch,
	setTextRecruitDataFromExtension,
	setCurrentExtensionWebPageOrigin
};
